import { css } from 'styled-components';
import animationDurationInMS from '../../primitives/duration';
import animationEasingCurves from '../../primitives/easing';
var defaults = {
  scaleTarget: 1.05,
  duration: animationDurationInMS.faster,
  easing: animationEasingCurves.easeBoth,
  delay: 0
};

var scale = function scale(configuration) {
  var _configuration$durati, _configuration$easing, _configuration$delay, _configuration$scaleT;

  return css(["transition:transform ", "ms ", " ", "ms;transform:scale(", ");@media (prefers-reduced-motion:reduce){transition:none;}"], (_configuration$durati = configuration === null || configuration === void 0 ? void 0 : configuration.duration) !== null && _configuration$durati !== void 0 ? _configuration$durati : defaults.duration, (_configuration$easing = configuration === null || configuration === void 0 ? void 0 : configuration.easing) !== null && _configuration$easing !== void 0 ? _configuration$easing : defaults.easing, (_configuration$delay = configuration === null || configuration === void 0 ? void 0 : configuration.delay) !== null && _configuration$delay !== void 0 ? _configuration$delay : defaults.delay, (_configuration$scaleT = configuration === null || configuration === void 0 ? void 0 : configuration.scaleTarget) !== null && _configuration$scaleT !== void 0 ? _configuration$scaleT : defaults.scaleTarget);
};

export default scale;